// Build the client-side reply snapshot shown in the composer preview and on
// the optimistic message. The server re-resolves the snapshot from messageId.

export const buildReplyTarget = (msg) => {
  if (!msg?._id) return null;
  const preview = msg.message?.trim()
    ? msg.message.trim().slice(0, 140)
    : msg.poll?.question
    ? `Poll: ${msg.poll.question.slice(0, 120)}`
    : 'Message';
  return {
    messageId: String(msg._id),
    userName: msg.userId?.name || 'Unknown',
    preview,
  };
};
